export default "__VITE_ASSET__b261e0f7__"